<template>
  <div class="top-spacer"></div>
  <div class="news-detail">
    <div class="container">
      <div class="back-btn">
        <a href="javascript:history.back()">← 返回</a>
      </div>
      <div class="cover" v-if="article.cover">
        <img :src="article.cover" :alt="article.title">
      </div>
      <h1 class="title">{{ article.title }}</h1>
      <time class="publish-time">{{ formatDate(article.date) }}</time>
      <div class="content">
        <p v-for="(paragraph, index) in article.content.split('\n')" :key="index">
          {{ paragraph }}
        </p>
      </div>
      <h1 class="title">产品细节图：</h1>
      <img style="width:100%" src="@/images/u365.png" alt="">
      
      <h1 class="title">规格参数：</h1>
      <Table />
      <h1 class="title">产品竞争优势：</h1>
      <ul>
        <li>流程全面化：高清图文自动存证，复核记录全程追溯</li>
<li>功能齐全化：支持多盒/多种/批号/效期复核/条码/钢印/追溯码核验</li>
<li>准确：六面视觉核验丶AI智能识别丶智慧核对丶声光异常报警</li>
<li>快速：一查丶二放丶三扫操作简便，核对时间大幅缩短</li>
<li>高效：每小时可完成2000件的药品检验工作，大幅提升仓库分拣检验工作效率，准确率高</li>
      </ul>

    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import Table from '@/components/Table/trayRedcodeTable.vue'

const article = ref({
  id: 1,
  title: '托盘校验机',
  date: '2025-06-29',
  cover: require("@/images/u46.png"), 
  content: `杭州古峰智能科技有限公司专注为医药批发企业提供药品核验服务。公司立足全国市场，凭借强研发实力与前沿技术理念，可快速响应客户需求变化。其产品融入机器视觉与AI技术，能实现盒装、袋装药品自动核对，有效减少人工复核人员、降低作业要求，显著提升核验效率。`
})

function formatDate(dateString) {
  const date = new Date(dateString)
  return date.toLocaleDateString('zh-CN', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })
}

defineExpose({ formatDate })
</script>

<style scoped>
.top-spacer {
  height: 80px;
  width: 100%;
}

.news-detail {
  background-color: #f8f9fa;
  padding: 40px 20px;
  min-height: 100vh;
  font-family: 'Segoe UI', sans-serif;
}

.container {
  max-width: 800px;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  padding: 30px;
}

.back-btn {
  margin-bottom: 20px;
}

.back-btn a {
  text-decoration: none;
  color: #007bff;
  font-size: 14px;
}

.cover {
  width: 100%;
  overflow: hidden;
  border-radius: 10px;
  margin-bottom: 20px;
}

.cover img {
  width: 100%;
  height: auto;
  display: block;
}

.title {
  font-size: 28px;
  margin-bottom: 10px;
  color: #333;
}

.publish-time {
  display: block;
  color: #777;
  margin-bottom: 20px;
  font-size: 14px;
}

.content {
  line-height: 1.8;
  font-size: 16px;
  color: #555;
}

.content p {
  margin-bottom: 1em;
}
</style>